import type { Maybe } from 'src/types';

import type { ProfileVisibility2TypeNames } from '../ProfileVisibilityV2/types';

export const showApproachability = (
  profileVisibilityTypeName: Maybe<ProfileVisibility2TypeNames>,
) =>
  profileVisibilityTypeName !== 'HiddenVisibilityOption' &&
  profileVisibilityTypeName !== null;
